// frontend/src/components/book/BillingSection.jsx
import React, { useState, useEffect } from 'react';
import { api } from '../../api';
import { colors, fontFamily } from '../../theme';

export default function BillingSection() {
  const [current, setCurrent] = useState(null);
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const [currentData, historyData] = await Promise.all([
          api.getMyCurrentBilling(),
          api.getMyBillingHistory()
        ]);
        if (!cancelled) {
          setCurrent(currentData);
          setHistory(historyData.billing_history || []);
        }
      } catch (err) {
        if (!cancelled) setError('Failed to load billing information');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  if (loading) {
    return <p style={{ color: colors.textMuted }}>Loading billing information...</p>;
  }
  if (error) {
    return <p style={{ color: colors.negative }}>{error}</p>;
  }

  const billing = current?.billing;

  return (
    <div style={{ color: colors.textPrimary, fontFamily }}>
      <h2 style={{ color: colors.textPrimary, marginBottom: '1rem' }}>Billing</h2>

      {billing && (
        <div style={{ background: colors.cardBg, boxShadow: colors.shadowCard, borderRadius: 8, padding: '1.25rem', marginBottom: '1.25rem' }}>
          <p style={{ color: colors.textMuted, fontSize: '0.85rem', marginBottom: 6 }}>This Week (in progress)</p>
          <p style={{ fontSize: '0.95rem', marginBottom: 4, color: colors.textPrimary }}>
            Your rate: <strong>${billing.rate_per_active_user.toFixed(2)}</strong> / active user
          </p>
          <p style={{ fontSize: '0.9rem', marginBottom: 4, color: colors.textPrimary }}>
            {billing.active_user_count} active user{billing.active_user_count === 1 ? '' : 's'}
            {billing.live_user_count > 0 && ` · ${billing.live_user_count} live betting user${billing.live_user_count === 1 ? '' : 's'} (+$1.00 each)`}
          </p>
          <p style={{ fontSize: '1.1rem', fontWeight: 700, marginTop: '0.5rem', color: colors.gold }}>
            Running total: ${billing.total_amount.toFixed(2)}
          </p>
        </div>
      )}

      <div style={{ background: colors.cardBg, boxShadow: colors.shadowCard, borderRadius: 8, padding: '1.25rem' }}>
        <h3 style={{ color: colors.textPrimary, marginBottom: '0.75rem', fontSize: '1rem' }}>History</h3>
        {history.length === 0 ? (
          <p style={{ color: colors.textMuted }}>No past billing periods yet.</p>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.85rem' }}>
              <thead>
                <tr style={{ borderBottom: `1px solid ${colors.goldMuted}` }}>
                  <th style={{ color: colors.textMuted, padding: '0.5rem', textAlign: 'left', fontWeight: 'normal' }}>Week</th>
                  <th style={{ color: colors.textMuted, padding: '0.5rem', textAlign: 'center', fontWeight: 'normal' }}>Active Users</th>
                  <th style={{ color: colors.textMuted, padding: '0.5rem', textAlign: 'center', fontWeight: 'normal' }}>Rate</th>
                  <th style={{ color: colors.textMuted, padding: '0.5rem', textAlign: 'center', fontWeight: 'normal' }}>Total</th>
                  <th style={{ color: colors.textMuted, padding: '0.5rem', textAlign: 'center', fontWeight: 'normal' }}>Status</th>
                </tr>
              </thead>
              <tbody>
                {history.map(record => (
                  <tr key={record.id} style={{ borderBottom: `1px solid ${colors.sectionBg}` }}>
                    <td style={{ padding: '0.5rem', color: colors.textPrimary }}>
                      {new Date(record.period.period_start).toLocaleDateString()} – {new Date(record.period.period_end).toLocaleDateString()}
                    </td>
                    <td style={{ padding: '0.5rem', textAlign: 'center', color: colors.textPrimary }}>{record.active_user_count}</td>
                    <td style={{ padding: '0.5rem', textAlign: 'center', color: colors.textPrimary }}>${record.rate_per_active_user.toFixed(2)}</td>
                    <td style={{ padding: '0.5rem', textAlign: 'center', fontWeight: 600, color: colors.textPrimary }}>${record.total_amount.toFixed(2)}</td>
                    <td style={{ padding: '0.5rem', textAlign: 'center' }}>
                      {record.is_paid ? (
                        <span style={{ fontSize: '0.75rem', padding: '2px 8px', borderRadius: 20, background: `${colors.odds}33`, color: colors.odds }}>
                          {record.auto_paid_zero ? 'Paid ($0)' : 'Paid'}
                        </span>
                      ) : (
                        <span style={{ fontSize: '0.75rem', padding: '2px 8px', borderRadius: 20, background: `${colors.negative}33`, color: colors.negative }}>Unpaid</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
